import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { createContext, useState, useContext } from 'react';
const initialState = {
    debug: false,
    widgetMode: "default",
    orientation: "vertical",
    navigationMode: "basic",
    defaultOpened: {
        desktop: true,
        mobile: true
    },
    hasAccounts: false,
    hasLogin: false,
    hasRegistration: false,
    hasGuests: false,
    hasSubscriptions: false,
    hasMemberships: false,
    hasWaitinglists: false,
    hasResourceSelect: false,
    showSelectedResource: false,
    hasCheckout: false,
    hasOrders: false,
    hasShop: false,
    hasGroupedShop: false,
    multipleAppointments: false,
    showDetails: false,
    showCategories: false,
    hasGoogleLogin: false,
    prioritizeAria: false,
    widget_id: '0',
    api_key: '',
    forms: {
        consumer: [],
        business: [],
        appointment: []
    },
    contracts: [],
    payment: {
        providers: []
    },
    staticData: {
        resources: []
    }
};
export const SettingsContext = createContext(initialState);
export const useSettings = () => {
    return useContext(SettingsContext);
};
const SettingsProvider = ({ children, initial }) => {
    const [settings, setSettings] = useState(Object.assign(Object.assign({}, initialState), initial));
    return (_jsx(SettingsContext.Provider, { value: settings, children: children }));
};
export default SettingsProvider;
